import { c as _c } from "react/compiler-runtime";
import type { LocalMarketApiDto } from '__generated__/api/unauth/types.gen';
import { Fragment } from 'react';
import { SearchCategoryAdSlot } from '@/app/_components/ads';
import { SearchEmptyResults } from '../SearchEmptyResults';
import { SearchMarketCard } from './SearchMarketCard';
export function LocalMarketList(t0) {
  const $ = _c(7);
  const {
    items
  } = t0;
  if (items.length < 1) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SearchEmptyResults />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== items) {
    let t2;
    if ($[3] !== items.length) {
      t2 = (item, idx) => <Fragment key={item.localMarketProductId}><SearchCategoryAdSlot as="li" placement="search-local-market" position={idx + 1} listLength={items.length} /><li><SearchMarketCard productId={item.slugId ?? item.localMarketProductId} imageUrl={item.productImageUrl} productName={item.productName} region={item.region} originalPrice={item.originalPrice} expectedFinalPrice={item.expectedFinalPrice} discountRate={item.discountRate} rating={item.rating} reviewCount={item.reviewCount} /></li></Fragment>;
      $[3] = items.length;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = items.map(t2);
    $[1] = items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ul className="grid grid-cols-3 gap-x-16 gap-y-32 pb-40 mobile:gap-x-12 mobile:gap-y-24 mobile-tablet:grid-cols-2 mobile-tablet:px-20">{t1}</ul>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}